export class ErrorDictionaryService {
  dictionary = {
    1: 'کاربر گرامی، خطای غیر منتظره ای در برنامه رخ داده است، لطفا با پشتیبانی تماس بگیرید.',
    100: 'جواب آزمایش منقضی شده است.',
    101: 'برای دریافت جواب آزمایش به بیمارستان مراجعه نمایید.',
    102: 'برای دریافت جواب آزمایش به بیمارستان مراجعه نمایید.',
    200: 'جواب آزمایشی با این مشخصات یافت نگردید.'
  };

  get(businessRuleId: number): string {
    if (businessRuleId) {
      return this.dictionary[businessRuleId];
    } else {
      return this.dictionary['1'];
    }
  }
}
